import React, { useState } from 'react';

const BinomialCoefficientCalculator = () => {
  const [numCoefficients, setNumCoefficients] = useState(1);
  const [coefficients, setCoefficients] = useState([]);

  const calculateCoefficients = () => {
    let result = [];
    for (let n = 0; n <= numCoefficients; n++) {
      let row = [];
      for (let k = 0; k <= n; k++) {
        if (k === 0 || k === n) {
          row.push(1);
        } else {
          let prevRow = result[n - 1];
          row.push(prevRow[k - 1] + prevRow[k]);
        }
      }
      result.push(row);
    }
    setCoefficients(result);
  };

  return (
    <div>
      <h2>Binomial Coefficient Calculator</h2>
      <label htmlFor="numCoefficients">Enter number of coefficients (1-10): </label>
      <input
        type="number"
        id="numCoefficients"
        min="1"
        max="10"
        value={numCoefficients}
        onChange={(e) => setNumCoefficients(parseInt(e.target.value))}
      />
      <button onClick={calculateCoefficients}>Calculate</button>

      <div>
        {coefficients.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>n/k</th>
                {Array.from({ length: numCoefficients + 1 }, (_, index) => (
                  <th key={index}>{index}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {coefficients.map((row, index) => (
                <tr key={index}>
                  <th>{index}</th>
                  {row.map((coef, idx) => (
                    <td key={idx}>{coef}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default BinomialCoefficientCalculator;
